import { useEffect } from 'react';
import confetti from 'canvas-confetti';

const CANVAS_Z_INDEX = 10000;
const FALLBACK_PRIMARY = '#e25a28';
const NEUTRAL_COLORS = ['#ffd84d', '#48c9b0', '#ffffff'];

const channelsToHex = (channels) => {
  const parts = channels
    .split(/[\s,/]+/)
    .filter(Boolean)
    .slice(0, 3);
  if (parts.length < 3) return null;

  const bytes = parts.map((part) => Number(part));
  if (bytes.some((byte) => !Number.isFinite(byte))) return null;

  return `#${bytes
    .map((byte) =>
      Math.min(255, Math.max(0, Math.round(byte)))
        .toString(16)
        .padStart(2, '0')
    )
    .join('')}`;
};

const getBrandPalette = () => {
  const channels = getComputedStyle(document.documentElement)
    .getPropertyValue('--color-primary')
    .trim();
  const primary = (channels && channelsToHex(channels)) || FALLBACK_PRIMARY;
  return [primary, primary, ...NEUTRAL_COLORS];
};

const BASE_OPTIONS = {
  ticks: 160,
  gravity: 1.1,
  decay: 0.91,
  shapes: ['square', 'circle'],
  disableForReducedMotion: true,
};

const WAVES = [
  {
    delay: 0,
    particleCount: 90,
    spread: 100,
    startVelocity: 55,
    origin: { x: 0.5, y: 0.9 },
  },
  {
    delay: 250,
    particleCount: 50,
    angle: 60,
    spread: 70,
    startVelocity: 60,
    origin: { x: 0, y: 0.85 },
  },
  {
    delay: 500,
    particleCount: 50,
    angle: 120,
    spread: 70,
    startVelocity: 60,
    origin: { x: 1, y: 0.85 },
  },
];

export const usePromoConfetti = (isActive) => {
  useEffect(() => {
    if (!isActive) return undefined;

    const canvas = document.createElement('canvas');
    canvas.setAttribute('aria-hidden', 'true');
    Object.assign(canvas.style, {
      position: 'fixed',
      top: '0',
      left: '0',
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      zIndex: String(CANVAS_Z_INDEX),
    });
    document.body.appendChild(canvas);
    const fire = confetti.create(canvas, { resize: true, useWorker: true });
    const colors = getBrandPalette();

    const timers = WAVES.map(({ delay, ...wave }) =>
      setTimeout(() => fire({ ...BASE_OPTIONS, ...wave, colors }), delay)
    );

    return () => {
      timers.forEach(clearTimeout);
      fire.reset();
      canvas.remove();
    };
  }, [isActive]);
};
